import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	background: #f5f7fa;
	border-radius: 6px;
	margin: 50px 0;
	padding: 22px;
	width: 100%;
`;

export const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding-bottom: 24px;
	border-bottom: 2px solid ${tokens.color_gray_medium};

	h3 {
		font-family: ${tokens.font_family_primary};
		font-style: normal;
		font-weight: 600;
		font-size: 16px;
		color: ${tokens.color_gray_dark};
	}

	p {
		font-family: ${tokens.font_family_primary};
		font-weight: 500;
		font-size: 14px;
		color: ${tokens.color_gray_dark};
	}
`;

export const ContentContainer = styled.div`
	display: grid;
	padding-top: 24px;
	grid-template-columns: 0.35fr 1fr;
`;

export const DonutsContainer = styled.div`
	display: flex;
	gap: 24px;
`;

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-left: 75px;
	padding-top: 24px;

	h2 {
		font-family: ${tokens.font_family_primary};
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		color: ${tokens.color_primary};
	}

	p {
		font-family: ${tokens.font_family_primary};
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		color: ${tokens.color_gray_dark};
	}
`;
